import React from 'react';

import { Route, Switch } from 'react-router';
import { r } from '../../../../routes';
import { ProductPaymentAmount } from './Amount';
import { ProductPaymentOptIn } from './OptIn';
import { ProductPaymentPayment } from './Payment';

export const ProductPayment: React.FC = () => {
  return (
    <Switch>
      <Route exact={true} path={r.generalFlow.productPayment.index()} component={ProductPaymentOptIn} />
      <Route exact={true} path={r.generalFlow.productPayment.amount()} component={ProductPaymentAmount} />
      <Route exact={true} path={r.generalFlow.productPayment.payment({})} component={ProductPaymentPayment} />
    </Switch>
  );
};
